import { render, staticRenderFns } from "./question-11.vue?vue&type=template&id=ec3b9d18&scoped=true&lang=pug"
var script = {}
import style0 from "./question-11.vue?vue&type=style&index=0&id=ec3b9d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3b9d18",
  null
  
)

export default component.exports